import Api from "gurhan/helpers/Api";
import router from "@router";
import { BASE_URL, BASE_URL_IMAGE } from "./BaseUrl";
import { GEOMETRY_PREFIX_URL } from "./Endpoints/Geometry";
import { COMPRESSOR_BRANDS_PREFIX_URL } from "./Endpoints/CompressorBrands";
import { COMPRESSOR_BRAND_REFRIGERANTS_PREFIX_URL } from "./Endpoints/CompressorBrandRefrigerants";
import { COMPRESSOR_REFRIGERANT_MODELS_PREFIX_URL } from "./Endpoints/CompressorRefrigerantModels";
import { FIN_PITCHES_PREFIX_URL } from "./Endpoints/FinPitches";
import { MATERIALS_PREFIX_URL } from "./Endpoints/Materials";
import { REFRIGERANTS_PREFIX_URL } from "./Endpoints/Refrigerants";
import { SERIES_PREFIX_URL } from "./Endpoints/Series";
import { THICKNESSES_PREFIX_URL } from "./Endpoints/Thicknesses";
/**
 * Tüm requestler için yazılmış API HELPER module'üdür.
 * api.get(url);
 *
 * api.post(url, data);
 *
 * api.put(url, data)
 *
 * api.delete(url, data)
 *
 * api.token = String - Tüm requestlerde headers kısmına ekler.
 *
 * @param {object} Options - API bağlantı bilgileri
 *
 * @param {string} Options.baseUrl - Base url
 */
const api = new Api({
  baseUrl: BASE_URL, // api adresi,
  baseUrlImage: BASE_URL_IMAGE, // image adresi,
  bearerToken: true, // bearer token kullanılacaksa true değilse false,
  errorStatus: [400, 401, 403, 404, 500, 502], // uygulama hangi hata code'larını aldığında login'e gönderilir.
  loginRouterName: "Login",
  loginUrl: "/#/account/sign-in", // login için hangi url'e istek atacağını belirtir.
  vueRouter: router, // uygulamanın route bilgisini gönderir ve içerideki yönlendirmeleri yapar.
  cache: true,
  cachableList: [
    GEOMETRY_PREFIX_URL,
    COMPRESSOR_BRANDS_PREFIX_URL,
    COMPRESSOR_BRAND_REFRIGERANTS_PREFIX_URL,
    COMPRESSOR_REFRIGERANT_MODELS_PREFIX_URL,
    FIN_PITCHES_PREFIX_URL,
    MATERIALS_PREFIX_URL,
    REFRIGERANTS_PREFIX_URL,
    SERIES_PREFIX_URL,
    THICKNESSES_PREFIX_URL,
    "/AuthorityDepartmentUser/GetAuthorities",
  ],
  cacheTime: 1000 * 60 * 60 * 24,
});

export default api;
